<div class="contact-card">
  <div class="contact-card-header">
    <h3 class="contact-card-title font-m">
      {{ "features.contacts.contactCardTitle" | translate }}
    </h3>
    <a
      href="{{ contact.contactLink }}"
      target="_blank"
      class="font-xs contact-link contact-card-link"
      >{{ "features.contacts.links.link" | translate }}
      <img
        src="/pia/icons/open_in_new.svg"
        alt="{{ 'pia.features.contacts.links.openInNewTabIcon' | translate }}"
    /></a>
  </div>
  <div class="contact-card-content">
    <div class="contact-card-icon-wrapper">
      <span class="icon-image-frame">
        <img
          src="/pia/icons/person.svg"
          alt="{{ 'pia.features.contacts.links.supportIcon' | translate }}"
        />
      </span>
    </div>
    <div class="contact-card-text font-xs">
      <p class="contact-name">{{ contact.contactName }}</p>
      <a href="tel:{{ contact.contactPhone }}" class="contact-phone"
        >Tel. {{ contact.contactPhone }}</a
      >
      <a href="mailto:{{ contact.contactEmail }}" class="contact-link">{{
        contact.contactEmail
      }}</a>
    </div>
  </div>
</div>
